export const MAX_FILE_SIZE = 157286400;
export const MAX_AUTHORS_COUNT = 2;
export const DRAFT_STATUS = 0;
export const MAX_TAG_COUNT = 15;
export const MAX_PLACES_TAG_COUNT = 2;
export const LONGREAD_COUNT_WITHOUT_COVER = 1;

export const DRAFT_TAB_POSTFIX = '?tab=drafts';
export const PRO_DRAFT_TAB_POSTFIX = '?tab=drafts';
export const BOOK_DRAFT_TAB_POSTFIX = '?tab=draft_books';export const MAX_FILE_SIZE = 157286400;
export const MAX_AUTHORS_COUNT = 2;
export const DRAFT_STATUS = 0;
export const MAX_TAG_COUNT = 15;
export const MAX_PLACES_TAG_COUNT = 2;
export const LONGREAD_COUNT_WITHOUT_COVER = 1;

export const DRAFT_TAB_POSTFIX = '?tab=drafts';
export const PRO_DRAFT_TAB_POSTFIX = '?tab=drafts';
export const BOOK_DRAFT_TAB_POSTFIX = '?tab=draft_books';